<template>
	<div class="organization-release-note-company-list">
		<div class="organization-release-note-company-list__content">
			<p
				v-if="setup.list.length"
				class="organization-release-note-company-list__title">
				Nous avons trouvé <strong> {{ `société`.pluralize(setup.list.length, true) }} </strong>
				qui {{ setup.list.length > 1 ? 'vont' : 'va' }} pouvoir bénéficier de cette nouvelle organisation.
				<span v-if="setup.list.length > 1">
					<br>
					Nous les avons regroupées par agence.
				</span>
			</p>

			<o-list
				v-model:page="setup.listPage"
				class="organization-release-note-company-list__companies"
				v-bind="setup.listProps"
				:list="setup.companiesByAgency">
				<template #default="{ item: agency }: { item: typeof setup.companiesByAgency[number] }">
					<div class="organization-release-note-company-list__company-sticker">
						<div class="organization-release-note-company-list__company-logo">
							<o-icon font-icon="icon-interface-home-2"/>
						</div>

						<details
							open
							class="organization-release-note-company-list__company-infos">
							<summary
								class="
                organization-release-note-company-list__company-title
                organization-release-note-company-list__company-title--agency
                ">
								Agence <span class="text--info">{{ agency.agencyCompanyName }}</span> ({{ agency.companies.length }})
							</summary>

							<div class="organization-release-note-company-list__company-clients">
								<div
									v-for="company in agency.companies"
									:key="company.id"
									class="organization-release-note-company-list__company-sticker">
									<div class="organization-release-note-company-list__company-logo">
										<o-icon font-icon="icon-interface-user-home"/>
									</div>
									<div class="organization-release-note-company-list__company-infos">
										<p class="organization-release-note-company-list__company-title">{{ company.name }}</p>
										<p class="organization-release-note-company-list__company-address">
											{{ company.contactDetailCity }} {{ company.contactDetailPostCode }}
										</p>
									</div>
								</div>
							</div>
						</details>
					</div>
				</template>
			</o-list>
		</div>

		<o-loader :visible="setup.dataLoading"/>
	</div>
</template>

<script setup lang="ts">
import OrganizationReleaseNoteCompanyListSetupService from '@/setup/organization/OrganizationReleaseNoteCompanyListSetupService';
// const props = defineProps(OrganizationReleaseNoteCompanyListSetupService.props);
const setup = new OrganizationReleaseNoteCompanyListSetupService(/* props */);
</script>

<style scoped lang="less">
.organization-release-note-company-list {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: auto;
  min-height: 10rem;

  &__companies {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
		margin-top: 2rem;
		overflow: hidden;
  }

  &__company-sticker {
    display: flex;
    align-items: flex-start;
    gap: 1rem;

    .organization-release-note-company-list__company-clients & {
      gap: 1rem;
      align-items: center;
    }
  }

  &__company-clients {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1.5rem;
    margin-left: -1.5rem;
  }

  &__company-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    width: 2.5rem;
    flex: 0 0 2.5rem;
    border-radius: 0.25rem;
    background-color: var(--grey-light);
  }

  &__company-infos {
    flex: 1;
  }

  &__company-title, &__company-address {
    margin: 0;
    font-size: 0.85rem;
  }

  &__company-title {
    color: var(--grey-darker);
    font-weight: 600;

    &--agency {
      margin: 0.5rem 0;
      cursor: pointer;
    }
  }

  &__company-address {
    color: var(--grey-dark);
  }
}
</style>
